module.exports = __webpack_public_path__ + "img/Abstract-newdev.9e1516fc.svg";